import NewsCard from "@components/shared/NewsCard/NewsCard";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { GQLAttachments, GQLPosts, GQLTags, GQLUrls } from "@gql/types/gql";
import { translate } from "@helpers/translationObjectFormatter";
import useWindowSize from "@hooks/useWindowSize";
import { useQuery } from "@tanstack/react-query";
import React from "react";

const InCaseYouMissedIt = () => {
    const { data: missedNews } = useQuery<GQLPosts[]>(["missedNews"]);
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const { width } = useWindowSize();
    return (
        <div className="flex flex-col gap-10 my-20">
            <div className="flex items-center justify-between">
                <h2 className="font-bold text-3xl sm:text-4xl">
                    {translate(translations, "several_news_inCaseYouMissedIt")}
                </h2>
                {width > 640 && (
                    <a href={"/news/tags"} className="font-semibold">
                        {translate(
                            translations,
                            "several_general_showMoreButton",
                        )}
                    </a>
                )}
            </div>
            <div className="flex flex-wrap items-center justify-between gap-8">
                {missedNews?.map((item) => (
                    <NewsCard
                        key={item.title}
                        image={item.image as GQLAttachments}
                        title={item.title as string}
                        tags={item.tags as GQLTags[]}
                        url={item.url as GQLUrls}
                    />
                ))}
            </div>
            {width < 640 && (
                <a href={"/news/tags"} className="font-semibold text-center">
                    {translate(translations, "several_general_showMoreButton")}
                </a>
            )}
        </div>
    );
};

export default InCaseYouMissedIt;
